<div class="teaser" disable-empty>
    <h2 i18n="@@landingpage.register.teaser.headline" disable-empty format-text>null</h2>
    <p i18n="@@landingpage.register.teaser.text" disable-empty format-text>null</p>
</div>
<form [formGroup]="registrationForm" (submit)="register()">
    <validation [message]="registrationError"></validation>
    <div class="form-row">
        <label for="email" i18n="@@registration.label.email">E-mail address</label>
        <input name="email"
            id="email"
            value=""
            type="text"
            formControlName="email"
            #email 
            [class.error]="registrationForm.controls.email.invalid && registrationForm.controls.email.touched"
            test-id="registration.input.email">
        <validation [control]="registrationForm.controls.email">
            <validation-message type="required" i18n="@@registration.error.email.required">The 'e-mail address' is required.</validation-message>
        </validation>
    </div>
    <div class="form-row">
        <label for="activation-key">
            <span i18n="@@registration.label.activationkey">Activation Key</span>
            <a
                class="fa fa-question-circle label-help"
                disable-empty
                title="null"
                i18n="@@registration.label.activationkey.help.text"
                i18n-title="@@registration.label.activationkey.help.text"
                i18n-href="@@registration.label.activationkey.help.link"
                href="null"
                target="_blank"
            >null</a>
        </label>
        <input name="activation-key" 
            id="activation-key" 
            value="" 
            type="text" 
            formControlName="activationKey" 
            #activationkey 
            [class.error]="registrationForm.controls.activationKey.invalid && registrationForm.controls.activationKey.touched"
            test-id="registration.input.activationkey">
        <validation [control]="registrationForm.controls.activationKey">
            <validation-message type="required" i18n="@@registration.error.activationKey.required">'New activation key' is required.</validation-message>
        </validation>
    </div>
    <div class="form-row" *ngIf="showTenantKey">
        <label for="tenant-key">
            <span i18n="@@registration.label.tenantkey">Tenant key</span>
            <a
                class="fa fa-question-circle label-help"
                disable-empty
                title="null"
                i18n="@@registration.label.tenantkey.help.text"
                i18n-title="@@registration.label.tenantkey.help.text"
                i18n-href="@@registration.label.tenantkey.help.link"
                href="null"
                target="_blank"
            >null</a>
        </label>
        <input name="tenant-key" 
            id="tenant-key"
            value=""
            type="text"
            formControlName="tenantKey"
            i18n-placeholder="@@registration.tenantkey.input.placeholder"
            #tenantkey
            placeholder="Optional"
            test-id="registration.input.tenantkey">
    </div>
    <div class="button-row left-align" *ngIf="showTermsOfUse">
        <label class="accept">
            <input type="checkbox"
                name="accept"
                value="true"
                formControlName="accept"
                test-id="registration.input.accepttermsofuse"
            >
            <label [class.error]="registrationForm.controls.accept.invalid && registrationForm.controls.accept.touched">
                <a i18n-href="@@registration.label.accept.link"
                    target="_blank"
                    href="http://www.siemens.com/terms_of_use"
                    rel="noopener noreferrer"
                    class="notice"
                    i18n="@@registration.label.accept.text"
                    test-id="registration.link.termsofuse">Attention and Acceptance of the Terms of Use</a>
            </label>
        </label>
    </div>
        <div class="button-row left-align">
        <button class="default submit white-spinner"
            type="submit"
            [attr.state]="registerButtonState"
            i18n="@@registration.button.signup"
            *ngIf="!disableSignupButton"
            test-id="registration.button.submit">Sign up</button>
        <span
            class="login-button-seperator"
            *ngIf="showExternalLogin && !disableSignupButton"
            i18n="@@registration.button.seperator.text"
        >or</span>
        <a class="button default submit external-login"
            (click)="useExternalLogin()"
            i18n="@@registration.external.login.link"
            *ngIf="showExternalLogin"
            test-id="registration.link.externallogin"
        >External Log in</a>
    </div>
</form>